import React, { useCallback } from 'react';

import AddressSearch from '../../../../../Shared/React/js/components/addressSearch/AddressSearch';
import { ScreenSize } from '../../../../../Shared/React/js/utils/Hooks';
import type { Props } from './@types/Filters';
import SearchButton from './SearchButton';
import SpeedDataSelect from './SpeedDataSelect';

const screenSize: ScreenSize = ScreenSize.Desktop;

const FiltersLg = (props: Props) => {
    const onSearchClick = useCallback(() => props.onSearchClick(screenSize), [props]);

    return (
        <>
            <div className="pad-t-5 pad-b-3-xs pad-b-5-sm">
                <div className="row">
                    <div className="col-sm-14 col-sm-offset-1">
                        <div className="visible-md visible-lg">
                            <AddressSearch
                                {...props.addressSearchProps}
                                ref={props.addressSearchProps.ref}
                                className={`input-group input-group-lg ${props.marginCss}`}
                                inputClassName="font-5"
                                hideLabel={true}
                            >
                                <div className="input-group-btn">
                                    <SpeedDataSelect {...props.speedDataSelectProps} screenSize={screenSize} />
                                    <SearchButton
                                        text={props.searchButtonText}
                                        isLoading={props.isLoading}
                                        onClick={onSearchClick}
                                    />
                                </div>
                            </AddressSearch>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FiltersLg;
